module.exports = __webpack_public_path__ + "static/img/sample_image@3x.37a231f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/whk/sample_image@3x.png
// module id = tS6f
// module chunks = 1